(function () {
  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      const args = arguments;
      t = setTimeout(function () {
        fn.apply(null, args);
      }, ms);
    };
  }

  function shuffle(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  }

  function capForWidth(root, w) {
    const sm = parseInt(root.dataset.maxSm || '6', 10);
    const md = parseInt(root.dataset.maxMd || '12', 10);
    const lg = parseInt(root.dataset.maxLg || '20', 10);
    if (w < 750) return Math.max(0, sm);
    if (w < 990) return Math.max(0, md);
    return Math.max(0, lg);
  }

  function apply(root) {
    const floats = root.querySelectorAll('.bbs-hero__float');
    if (!floats.length) return;

    let order = root._bbsFloatOrder;
    if (!order || order.length !== floats.length) {
      order = shuffle(Array.from({ length: floats.length }, (_, i) => i));
      root._bbsFloatOrder = order;
    }

    const k = Math.min(capForWidth(root, window.innerWidth), floats.length);
    const show = new Set(order.slice(0, k));

    floats.forEach(function (el, i) {
      el.classList.toggle('is-bbs-float-hidden', !show.has(i));
    });
  }

  function teardown(root) {
    if (!root || root.dataset.bbsHeroFloatsInit !== '1') return;
    if (root._bbsDebouncedResize) {
      window.removeEventListener('resize', root._bbsDebouncedResize);
      root._bbsDebouncedResize = null;
    }
    delete root._bbsFloatOrder;
    root.dataset.bbsHeroFloatsInit = '0';
  }

  function init(root) {
    if (!root) return;
    teardown(root);

    root.dataset.bbsHeroFloatsInit = '1';

    apply(root);

    const debounced = debounce(function () {
      apply(root);
    }, 180);
    root._bbsDebouncedResize = debounced;
    window.addEventListener('resize', debounced);
  }

  function boot() {
    document.querySelectorAll('[data-bbs-hero-floats]').forEach(init);
  }

  if (!window.__bbsHeroFloatsBooted) {
    window.__bbsHeroFloatsBooted = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (!(e.target instanceof HTMLElement)) return;
      e.target.querySelectorAll('[data-bbs-hero-floats]').forEach(init);
    });
  } else {
    boot();
  }
})();
